var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistoryCheckIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4605",
    "data-name": "Group 4605",
    transform: "translate(-1424 -1264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3575",
    "data-name": "Group 3575",
    transform: "translate(24 -24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1225",
    "data-name": "Rectangle 1225",
    width: 12,
    height: 12,
    transform: "translate(1400 1288)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check",
    d: "M12.564,6,6.676,12.088,4,9.321",
    transform: "translate(1397.718 1284.956)",
    fill: "none",
    stroke: "#058728",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryCheckIcon);
export default __webpack_public_path__ + "static/media/history-check-icon.0676797742e39b311ad90c65040abad9.svg";
export { ForwardRef as ReactComponent };